import AppController from './AppController';
import StoreController from '@projeccions-pdc/frontend-storage';
import LocalizedStrings from './Components/Localization/localization';
import LocalizedStringsLibrary from './Components/Library/localization';
import Amplify from 'aws-amplify';
export default class AppContext {
    static instance;

    constructor() {
        if (AppContext.instance) {
            return AppContext.instance;
        }

        this.state = {};
        this.loadLanguage();
        AppContext.instance = this;
    }

    loadLanguage = () => {
        let _StoreControllerNoPlatform = new StoreController('', '');
        let response = _StoreControllerNoPlatform.get('language');
        let lang = response ? response : 'en';
        this.state.currentLanguage = lang;
        LocalizedStrings.setLanguage(lang);
        LocalizedStringsLibrary.setLanguage(lang);
    };
    setLanguage = (lang) => {
        this.state.currentLanguage = lang;
        let _StoreControllerNoPlatform = new StoreController('', '');
        _StoreControllerNoPlatform.set('language', lang);
        LocalizedStrings.setLanguage(lang);
        LocalizedStringsLibrary.setLanguage(lang);
        this.notifyObservers('setLanguage');
    };
    getLanguage = () => {
        return this.state.currentLanguage;
    };

    setToken = async (token, isSharedToken, isSessionValid, redirectLogin) => {
        let oldToken = this.state.token;
        let mustNotify = false;

        if ((this.state.token === undefined && token !== undefined) || (this.state.token === 'offline' && token !== undefined)) {
            mustNotify = true;
        }

        this.state.token = token;
        this.state.isSharedToken = isSharedToken;
        this.state.isSessionValid = isSessionValid;
        this.state.redirectLogin = redirectLogin;
        if (oldToken !== this.state.token) {
            await this.updateContainerAppConfig();
        }
        if (mustNotify === true) {
            this.notifyObservers('setToken');
        }
    };
    getToken = () => {
        return this.state.token;
    };
    getIsSharedToken = () => {
        return this.state.isSharedToken;
    };
    getIsSessionValid = () => {
        return this.state.isSessionValid;
    };
    getRedirectLogin = () => {
        return this.state.redirectLogin;
    };

    setConfig = (config) => {
        this.state.config = config;
        this.configureAmplify();
        // console.log('setConfig', config)
    };
    getConfig = () => {
        return this.state.config;
    };

    setPlatformId = async (newPlatformId, evt) => {
        if (process.env.REACT_APP_IS_CONTAINER === 'true' || this.state.platformId === undefined) {
            let mustReload = false;
            if (this.state.platformId !== undefined) {
                mustReload = true;
            }

            this.state.platformId = newPlatformId;
            let _StoreControllerNoPlatform = new StoreController('', '');
            _StoreControllerNoPlatform.set('defaultPlatformId', newPlatformId);

            if (mustReload === true) {
                window.location.href = '/index.html';
            } else {
                this.updateContainerAppConfig();
                // await AppController.refreshPlatformConfig(this.state.config, this.state.platformId);
                if (this.state.token !== undefined) {
                    await AppController.loadPlatformAndUserData(
                        this.state.token,
                        this.state.config,
                        this.state.platformId,
                        this.state.myPlatforms
                    );
                }
            }
        } else {
            let config = this.state.config;
            let baseUrl = `https://${newPlatformId}.${config.PdcDomain}`;

            let openTo = '_self';
            if (evt && (evt.ctrlKey || evt.metaKey)) {
                openTo = '_blank';
            }
            window.open(baseUrl, openTo);
        }
    };
    getPlatformId = () => {
        return this.state.platformId;
    };

    getMyPlatforms = () => {
        return this.state.myPlatforms;
    };
    setMyPlatforms = (myPlatforms) => {
        this.state.myPlatforms = myPlatforms;
    };

    getCanUsePlatform = () => {
        return this.state.canUsePlatform;
    };
    setCanUsePlatform = (canUsePlatform) => {
        this.state.canUsePlatform = canUsePlatform;
    };

    getMyInfo = () => {
        return this.state.myInfo;
    };
    setMyInfo = (myInfo) => {
        this.state.myInfo = myInfo;
    };
    getUserProfileData = () => {
        if (this.state.userProfileData !== undefined) {
            return this.state.userProfileData;
        } else {
            // Failsafe
            return {
                company: '',
                salute: '',
                position: '',
                country: '',
                city: '',
                area: '',
            };
        }
    };
    setUserProfileData = (userProfileData) => {
        this.state.userProfileData = userProfileData;
    };

    setPlatformConfig = (platformConfig) => {
        let corporateColors = [];
        if (platformConfig && platformConfig.customStyles) {
            Object.keys(platformConfig.customStyles).forEach((key) => {
                if (
                    platformConfig.customStyles[key].indexOf('#') > -1 &&
                    corporateColors.indexOf(platformConfig.customStyles[key]) === -1
                ) {
                    corporateColors.push(platformConfig.customStyles[key]);
                }
            });
        }
        platformConfig.corporateColors = corporateColors;
        if (!platformConfig.corporateIcons) platformConfig.corporateIcons = [];

        let namedColors = [];
        const namedColorsNames = [
            'primaryColor',
            'secondaryColor',
            'tertiaryColor',
            'quaternaryColor',
            'quinaryColor',
            'senaryColor',
            'septenaryColor',
            'octonaryColor',
            'nonaryColor',
            'denaryColor',
        ];
        if (platformConfig && platformConfig.customStyles) {
            for (let nc of namedColorsNames) {
                if (platformConfig.customStyles[nc] !== undefined) {
                    namedColors.push(platformConfig.customStyles[nc]);
                }
            }
        }
        platformConfig.namedColors = namedColors;
        this.state.platformConfig = platformConfig;
        this.configureAmplify();
        // console.log('setPlatformConfig', platformConfig);
    };
    getPlatformConfig = () => {
        return this.state.platformConfig;
    };

    updateContainerAppConfig = async () => {
        if (process.env.REACT_APP_IS_CONTAINER === 'true') {
            //TABLET & SMARTPHONE
            if (this.state.platformId !== undefined && this.state.token !== undefined) {
                await AppController.updateContainerAppConfig(this.state.token, this.state.config, this.state.platformId);
            }
        }
    };

    addObserver = (observerId, observer) => {
        if (this.state.observers === undefined) {
            this.state.observers = {};
        }
        this.state.observers[observerId] = observer;
    };

    removeObserver = (observerId) => {
        delete this.state.observers[observerId];
    };

    notifyObservers = (topic) => {
        console.warn('notifyObservers', topic);
        if (this.state.observers !== undefined) {
            Object.keys(this.state.observers).forEach((observerId) => {
                let currObserver = this.state.observers[observerId];
                if (currObserver !== undefined) {
                    currObserver.notifyDataHasChanged();
                }
            });
        }
    };

    //Amplify
    configureAmplify = () => {
        let { config, platformConfig } = this.state;

        let oauthData = undefined;
        if (platformConfig !== undefined && platformConfig.federatedAuth !== undefined) {
            oauthData = {
                clientID: platformConfig.federatedAuth.federatedUserPoolClientId,
                domain: platformConfig.federatedAuth.federatedDomainName,
                scope: platformConfig.federatedAuth.federatedClaims,
                redirectUri: config.cognito.federatedCallbackUrl,
                returnTo: config.cognito.federatedCallbackUrl,
                responseType: config.cognito.federatedGrantFlow,
            };
        } else if (config.cognito.federatedUserPoolClientId !== undefined) {
            oauthData = {
                clientID: config.cognito.federatedUserPoolClientId,
                domain: config.cognito.federatedDomainName,
                scope: config.cognito.federatedClaims,
                redirectUri: config.cognito.federatedCallbackUrl,
                returnTo: config.cognito.federatedCallbackUrl,
                responseType: config.cognito.federatedGrantFlow,
            };
        }

        console.log('AMPLIFY CONFIG', {
            Analytics: {
                // OPTIONAL - disable Analytics if true
                disabled: true,
            },
            Auth: {
                mandatorySignIn: true,
                region: config.region,
                userPoolId: config.cognito.userPoolId,
                userPoolWebClientId: config.cognito.appClientId,
                oauth:
                    oauthData !== undefined
                        ? {
                              ...oauthData,
                              awsCognito: {
                                  ...oauthData,
                                  options: {
                                      oauth: {
                                          clientID: oauthData.clientID,
                                      },
                                      returnTo: oauthData.returnTo,
                                  },
                              },
                          }
                        : undefined,
            },
        });

        Amplify.configure({
            Analytics: {
                // OPTIONAL - disable Analytics if true
                disabled: true,
            },
            Auth: {
                mandatorySignIn: true,
                region: config.region,
                userPoolId: config.cognito.userPoolId,
                userPoolWebClientId: config.cognito.appClientId,
                oauth:
                    oauthData !== undefined
                        ? {
                              ...oauthData,
                              awsCognito: {
                                  ...oauthData,
                                  options: {
                                      oauth: {
                                          clientID: oauthData.clientID,
                                      },
                                      returnTo: oauthData.returnTo,
                                  },
                              },
                          }
                        : undefined,
            },
            API: {
                endpoints: [
                    {
                        name: 'identity',
                        endpoint: `https://identity.${config.ApiDomain}`,
                        region: config.region,
                    },
                    {
                        name: 'cc',
                        endpoint: `https://cc.${config.ApiDomain}`,
                        region: config.region,
                    },
                    {
                        name: 'form',
                        endpoint: `https://form.${config.ApiDomain}`,
                        region: config.region,
                    },
                    {
                        name: 'print',
                        endpoint: `https://print.${config.ApiDomain}`,
                        region: config.region,
                    },
                ],
            },
        });
        //console.log('Amplify Configured!', Auth.configure());
        // console.log('CONFIG PLATFORM', config, {
        //     endpoints: [
        //         {
        //             name: 'identity',
        //             endpoint: config.IdentityService,
        //             region: config.region,
        //         },
        //         {
        //             name: 'cc',
        //             endpoint: `https://cc.${config.ApiDomain}`,
        //             region: config.region,
        //         },
        //         {
        //             name: 'form',
        //             endpoint: config.FormService,
        //             region: config.region,
        //         },
        //         {
        //             name: 'print',
        //             endpoint: config.PrintService,
        //             region: config.region,
        //         },
        //     ],
        // });
    };
}
